import { BonusClassification, BonusSettlementSupplierStatus } from '@synergy/models';

export interface CustomerBonusSettlementSupplier {
    id: number;
    supplierId: number;
    supplierName: string;
    supplierCity?: string | null;
    bonusClassification?: BonusClassification | null;
    bonusConditions: {
        memberBonus: number;
        mode: BonusConditionMode;
        title: string;
        value: number;
    }[];
    status: BonusSettlementSupplierStatus;
    noteToCustomer?: string | null;
}

export enum BonusConditionMode {
    Amount = 'amount',
    Percentage = 'percentage',
}
